import { render, staticRenderFns } from "./VoucherGroup.vue?vue&type=template&id=326adc6f&"
import script from "./VoucherGroup.vue?vue&type=script&lang=js&"
export * from "./VoucherGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports